export function getUserLabel(user) {
  return user?.nombre_apellido ?? "Anónimo";
}
